import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import {
  PROJECTED_SITES_MANAGER,
  LOGBOOK,
  LOOKUP_TABLE_SINGLE,
} from 'constants/exportTypes'
import * as ApiRouter from 'constants/apiRouting'
import { SHOW_NOTICE } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import { EXPORT_TO_CSV } from './reducer'

function* exportToCsv({ payload, promise }) {
  try {
    const {
      type: payloadType,
      params,
      fileDownloadFailureMessage,
      siteType,
      snapshot,
      tableId,
    } = payload

    const exportUrls = {
      [LOOKUP_TABLE_SINGLE]: UrlHelper.create(
        ApiRouter.LOOKUP_TABLE_DATA_EXPORT_CSV_DATA,
        { id: tableId },
      ),
      [LOGBOOK]: ApiRouter.LB_EXPORT_CSV_DATA,
      [PROJECTED_SITES_MANAGER]:
        snapshot && snapshot !== 'main-table'
          ? UrlHelper.create(
              ApiRouter.PROJECTED_SITES_MANAGER_EXPORT_CSV_SNAPSHOT_DATA,
              { siteType, snapshot },
            )
          : UrlHelper.create(
              ApiRouter.PROJECTED_SITES_MANAGER_EXPORT_CSV_DATA,
              { siteType },
            ),
    }

    const url = exportUrls[payloadType]

    const { data, headers } = yield call(
      fetchFromAPI,
      {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.createQuery(
          `${url}${UrlHelper.getPsfsQuery(payload, {
            paginationParamsEnabled: false,
          })}`,
          params,
        ),
      },
      ['data', 'headers'],
    )

    if (data.hasOwnProperty('error')) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(data.message),
      })

      return yield call(promise.resolve)
    }

    if (
      !headers.hasOwnProperty('content-type') ||
      !headers.hasOwnProperty('content-disposition')
    ) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(fileDownloadFailureMessage),
      })

      return yield call(promise.resolve)
    }

    const type = headers['content-type'].toLowerCase().replace(' ', '')
    const [, filename] =
      headers['content-disposition'].match(/filename="([^"]+)"/i) || []

    if (!type || !filename) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(fileDownloadFailureMessage),
      })

      return yield call(promise.resolve)
    }

    const csvContent = new Blob([data], { type })
    const link = document.createElement('a')
    link.download = filename
    link.href = URL.createObjectURL(csvContent)
    link.click()
    URL.revokeObjectURL(link.href)

    yield call(promise.resolve)
  } catch (error) {
    console.log('EXPORT DATA FAILED', error)
  }
}

function* digitalLogbookSaga() {
  yield takeLatest(EXPORT_TO_CSV, exportToCsv)
}

export default digitalLogbookSaga
